/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=372d5b8a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=372d5b8a&lang=css"

import exportComponent from "/home/runner/work/lightandnight/lightandnight/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__